const calculateEdu = (age, schoolType, schoolFees) => {
    const remainingYears = 18 - (age < 6 ? 6 : age);
    const schoolCost = schoolFees[schoolType] * remainingYears;
    // console.log('SCHOOL', age, (schoolCost / 12));
    return schoolCost / 12;
}

export default (
    dept,
    expensesWeekly,
    otherIncomeAnnual,
    schoolType,
    childAges,
    {
        yearsStdLiving,
        funeralCost,
        childcareWeekly,
        schoolAnnualPrivate,
        schoolAnnualGovernment
    }
) => {
    // PREASSIGNED VARIABLES
    const childcareCostMonthly = childcareWeekly * 52 / 12;
    const schoolFees = {
        private: schoolAnnualPrivate,
        government: schoolAnnualGovernment
    }

    // SCHOOL
    const totalEducation = childAges.reduce((total, current) => {
        return total + Math.round(calculateEdu(current, schoolType, schoolFees));
    }, 0)
    const totalEducationMonthly = childAges.reduce((total, current) => {
        let cost = 0
        if (current  > 5) {
            cost = calculateEdu(current, schoolType, schoolFees) / (18 - current) / 12;
        }
        return total + cost;
    }, 0)


    //CHILDCARE
    const countChildrenUnder14 = childAges.filter(a => a < 14).length;
    const childcareTotalMonthly = childcareCostMonthly * countChildrenUnder14;

    const totalYearsOfChildcare = childAges.reduce((total, current) => {
        return total + (current < 14 ? (14 - current) : 0);
    }, 0)
    const totalCostOfChildcare = totalYearsOfChildcare * childcareWeekly * 52;


    //CALC
    const expensesMonthly = expensesWeekly * 52 / 12;
    const otherIncomeMonthly = otherIncomeAnnual / 12;
    const childcareAndEduTotalMonthly = childcareTotalMonthly + totalEducationMonthly;

    const ongoingExpensesExcChildcareDigest = (expensesMonthly - otherIncomeMonthly - childcareAndEduTotalMonthly) * yearsStdLiving * 12;
    const ongoingExpensesExcChildcare = ongoingExpensesExcChildcareDigest > 0 ? ongoingExpensesExcChildcareDigest : 0;

    const childrenCost = totalCostOfChildcare + totalEducation;

    const total = dept + ongoingExpensesExcChildcare + childrenCost + funeralCost;

    // console.log('______')
    // console.log(totalEducation)
    // console.log(totalEducationMonthly)

    // console.log('....')
    // console.log(childcareWeekly)
    // console.log(childcareTotalMonthly)
    // console.log(totalYearsOfChildcare)
    // console.log(totalCostOfChildcare)

    // console.log('...')
    // console.log(ongoingExpensesExcChildcare)
    // console.log('______')
    // console.log(total)

    return total;
}
